import React from "react";
import "./Fixed.css";

import { FaPhoneAlt, FaWhatsapp, FaEnvelope, FaInstagram, FaFacebook } from "react-icons/fa";

export default function Fixed() {
  return (
    <>
      <div className="fixed-wrapper">

        {/* CALL */}
        <a href="tel:+919095223243" className="fixed-btn call">
          <FaPhoneAlt />
        </a>

        {/* WHATSAPP */}
        <a href="https://wa.me/919095223243" target="_blank" rel="noreferrer" className="fixed-btn whatsapp">
          <FaWhatsapp />
        </a>

        {/* EMAIL */}
        <a href="mailto:srirajalakshmitravels@gmail.com" className="fixed-btn email">
          <FaEnvelope />
        </a>

        {/* INSTAGRAM */}
        <a href="https://www.instagram.com/sri_rajalakshmi_travels_aruppu/" target="_blank" rel="noreferrer" className="fixed-btn insta">
          <FaInstagram />
        </a>

        {/* FACEBOOK */}
        <a href="https://www.facebook.com/profile.php?id=61570304900604" target="_blank" rel="noreferrer" className="fixed-btn fb">
          <FaFacebook />
        </a>

      </div>
    </>
  );
}
